<div class="background identity-splash-screen">
  <div class="identity-card card padding-5">
    <ng-container *ngIf="registerStatus != 'REGISTER_ATTEMPT_COMPLETE'">
      <div class="adjustIconsToText">
        <span class="material-icons border-circle">construction</span>
        <span class="material-icons border-circle">train</span>
        <span class="material-icons border-circle">cases</span>
      </div>
      <!-- <h1 class="padding-y2">Sign up for a free 30-day trial</h1> -->
      <p class="register-title">Sign up</p>
      <h4>
        <b>
          Sign up to {{ tenant.tenantName }},
          <span class="highlight blue"
            >free for the first {{ freeTrial === 1 ? '1 day' : freeTrial + ' days' }}.</span
          >
        </b>
      </h4>
      <p>
        Enter your details below for a free {{ freeTrial }}-day limited-access trial - no credit
        card required.
      </p>
    </ng-container>
    <ng-container *ngIf="registerStatus == 'REGISTER_ATTEMPT_COMPLETE'">
      <br />
      <!-- @author Aidan -->
      <!-- Commented out - A heading like this is included in framework component. -->
      <!-- Kept the above <br> to ensure content stays centered. -->
      <!-- <div class="success-message">
        <h4><b>Registration successful!</b></h4>
      </div> -->
    </ng-container>
    <lib-page-register
      [showFields]="showFields"
      (registerStatusChange)="onRegisterStatusChange($event)"
    ></lib-page-register>
    <br />

    <div
      *ngIf="registerStatus == 'REGISTER_ATTEMPT_PENDING'"
      class="register-overlay d-flex fd-col jc-center ai-center"
    >
      <span class="register-status-message">Registering</span>
      <br />
      <mat-spinner></mat-spinner>
    </div>
  </div>
</div>

